import './App.css';

import Header from '../src/Components/Header.js';
import Footer from '../src/Components/Footer.js';

import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import {useNavigate} from 'react-router-dom'

import AllProductsTable from './Pages/ProductsTable.js';
import CreateCoaPage from '../src/Pages/CreateCoaPage.js';
import HomePage from '../src/Pages/HomePage.js';
import AllCoaPage from '../src/Pages/AllCoaPage.js';
import CoaPage from '../src/Pages/CoaPage.js';
import CoaEditPage from '../src/Pages/CoaEditPage.js';
import AboutUs from '../src/Pages/AboutUs.js';
import LoginPage from '../src/Pages/LoginPage.js';
import ContactUs from '../src/Pages/Contact';
import { topScroll } from './utils/productionvariable.js';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { loadUser } from './redux/actions/userAction.js';
import HPPage from './Pages/HPPage.jsx'

function App() {
  topScroll()

  const dispatch = useDispatch();
  // const navigata = useNavigate()

  // useEffect(() => {
  //   dispatch(loadUser())
  // }, [dispatch]);

 
  


  return (
    <BrowserRouter>
      {/* <Header /> */}

      <div className="downMargin">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/create-coa" element={<CreateCoaPage />} />
          <Route path="/all-coa" element={<AllCoaPage />} />
          <Route path="/coa/:coaId" element={<CoaPage />} />
          <Route path="/coa-edit/:coaId" element={<CoaEditPage />} />
          <Route path="/hf" element={<HPPage />} />
          {/* <Route path="/product/:id" element={<ProductPage />} />
         <Route path="/products" element={<AllProductsTable />} />
         <Route path="/about" element={<AboutUs />} />
         <Route path="/contact" element={<ContactUs />} /> */}
        </Routes>
      </div>

      {/* <Footer /> */}

    </BrowserRouter>
  );
}

export default App;
